import React, { FC, useState, useCallback } from 'react'
import "./PassKeyboard.css"
import { Keyboard } from 'components/keyboard/Keyboard';

interface PassKeyboard {
    password: string;
    onValidate: (validate: boolean) => void
}

export const PassKeyboard: FC<PassKeyboard> = ({ password, onValidate }) => {
    const [keyboardValue, setkeyboardValue] = useState<string[]>([])

    const onpressback = () => {
        setkeyboardValue(prev => prev.slice(0, prev.length - 1))

    }
    const onPressKey = useCallback((pressedKey: string) => {
        if (keyboardValue.length < 16) {
            setkeyboardValue(prev => [...prev, pressedKey])
        }
    },[keyboardValue])

    const onConfirm = useCallback(
      () => {
        if (keyboardValue.length === password.length) {
            const validation = keyboardValue.map((value, index) => {
                return value.includes(password[index])
            }).every((value) => value)
            console.log(validation)
            onValidate(validation);
        } else {
            onValidate(false);
        }
      },
      [keyboardValue, onValidate, password],
    )
    


    return (
        <div>
            <div className="input-passKeyboard">
                <div className="value-passKeyboard">
                    {keyboardValue.map(_value => "*")}
                </div>
            </div>
            <Keyboard 
                onKeyPress={onPressKey} 
                onPressEnter={onConfirm}
                onPressBack={onpressback}
                type='strongPassword'
            />
        </div>
    )
}
